import React from "react";
import styles from "./TopStepper.module.css";

/*
 * TopStepper — 3-circle horizontal progress at the top of GoLiveWizard.
 *
 * Maps from the wizard's 4 internal screens (AssignNumber, Carrier,
 * Forwarding, Triage) to 3 visual steps so user-facing language stays
 * simple:
 *
 *   Visual 1 "Assign Number"   → internal AssignNumber
 *   Visual 2 "Call Forwarding" → internal Carrier + Forwarding
 *   Visual 3 "Call Triage"     → internal Triage
 *
 * The mapping itself lives in GoLiveWizard; this component is dumb —
 * it just renders the three circles + connectors + labels and emits
 * an `onStepClick(visualNum)` event when the user taps a completed
 * circle. Active and pending circles are non-clickable.
 *
 * Per spec: clicking a completed circle navigates to the FIRST
 * internal screen of that visual step. The wizard handles the
 * mapping; this component just emits the visual step number.
 */

const STEPS = [
  { num: 1, label: "Assign Number" },
  { num: 2, label: "Call Forwarding" },
  { num: 3, label: "Call Triage" },
];

export default function TopStepper({ currentVisualStep = 1, onStepClick }) {
  return (
    <div className={styles.wrapper} role="progressbar" aria-valuenow={currentVisualStep} aria-valuemin={1} aria-valuemax={3}>
      <div className={styles.row}>
        {STEPS.map((step, idx) => {
          const isComplete = currentVisualStep > step.num;
          const isActive = currentVisualStep === step.num;
          const isClickable = isComplete && typeof onStepClick === "function";
          // Connector to the LEFT of this circle is "filled" when this
          // step OR any later step is reached. Connector to the RIGHT is
          // filled when the NEXT step has been reached.
          const showLeftConnector = idx > 0;
          const leftFilled = isComplete || isActive;

          return (
            <React.Fragment key={step.num}>
              <div className={styles.stepCol}>
                {/* Connector column ke andar absolute hai — pichhle circle se
                    is circle tak poori width leta hai, label se nahi katta. */}
                {showLeftConnector && (
                  <div
                    className={`${styles.connector} ${leftFilled ? styles.connectorFilled : ""}`}
                    aria-hidden="true"
                  />
                )}
                <button
                  type="button"
                  className={`${styles.circle} ${isComplete ? styles.complete : ""} ${isActive ? styles.active : ""} ${isClickable ? styles.clickable : ""}`}
                  onClick={() => {
                    if (!isClickable) return;
                    onStepClick(step.num);
                  }}
                  disabled={!isClickable}
                  aria-label={`Step ${step.num}: ${step.label}${isClickable ? " (click to revisit)" : ""}${isActive ? " (current)" : ""}`}
                  aria-current={isActive ? "step" : undefined}
                >
                  {isComplete ? (
                    <svg
                      width="16"
                      height="16"
                      viewBox="0 0 16 16"
                      fill="none"
                      aria-hidden="true"
                    >
                      <path
                        d="M3.5 8L6.5 11L12.5 5"
                        stroke="#fff"
                        strokeWidth="2.2"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      />
                    </svg>
                  ) : (
                    <span className={styles.num}>{step.num}</span>
                  )}
                </button>
                <span
                  className={`${styles.label} ${
                    isActive || isComplete ? styles.labelActive : ""
                  }`}
                >
                  {step.label}
                </span>
              </div>
            </React.Fragment>
          );
        })}
      </div>
    </div>
  );
}
